<template>
  <div class="cfye-form">
    <!-- MY PreSetAGMPanel 과 동일: 단일 헤더 행 + Applies to 칩 -->
    <div class="cfye-section">
      <div class="cfye-section-header">
        <Icon icon="mdi:domain" width="16" color="#888" />
        <span>Company</span>
        <div v-if="docList.length" class="cfye-section-docs">
          <span class="cfye-section-docs-label">Applies to:</span>
          <v-chip
            v-for="(name, i) in docList.slice(0, MAX_DOC_CHIPS)"
            :key="'c-' + i"
            size="x-small"
            variant="tonal"
            color="primary"
            class="cfye-doc-chip"
          >
            {{ name }}
          </v-chip>
          <span v-if="docList.length > MAX_DOC_CHIPS" class="cfye-more-chip">
            +{{ docList.length - MAX_DOC_CHIPS }}
          </span>
        </div>
      </div>
      <v-row dense>
        <v-col cols="12" md="8">
          <v-text-field
            v-model="model.companyName"
            label="Company name *"
            variant="outlined"
            density="compact"
            hide-details="auto"
            :readonly="!!readOnly"
          />
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field
            v-model="model.companyRegistrationNo"
            label="Registration No. *"
            variant="outlined"
            density="compact"
            hide-details="auto"
            :readonly="!!readOnly"
          />
        </v-col>
      </v-row>
    </div>

    <div class="cfye-section">
      <div class="cfye-section-header">
        <Icon icon="mdi:calendar-multiple" width="16" color="#888" />
        <span>Dates &amp; FYE</span>
        <div v-if="docList.length" class="cfye-section-docs">
          <span class="cfye-section-docs-label">Applies to:</span>
          <v-chip
            v-for="(name, i) in docList.slice(0, MAX_DOC_CHIPS)"
            :key="'d-' + i"
            size="x-small"
            variant="tonal"
            color="primary"
            class="cfye-doc-chip"
          >
            {{ name }}
          </v-chip>
          <span v-if="docList.length > MAX_DOC_CHIPS" class="cfye-more-chip">
            +{{ docList.length - MAX_DOC_CHIPS }}
          </span>
        </div>
      </div>
      <v-row dense>
        <v-col cols="12" md="6">
          <v-menu v-model="currentFyeMenu" :close-on-content-click="false" location="bottom" :disabled="!!readOnly">
            <template #activator="{ props: menuProps }">
              <v-text-field
                v-bind="menuProps"
                v-model="currentFyeDisplay"
                :placeholder="currentFyePlaceholder"
                label="Current FYE date *"
                variant="outlined"
                density="compact"
                hide-details="auto"
                readonly
                append-inner-icon="mdi-calendar"
                :disabled="!!readOnly"
              />
            </template>
            <v-date-picker
              v-bind="currentFyePickerProps"
              v-model="currentFyePickerValue"
              @update:model-value="currentFyeMenu = false"
            />
          </v-menu>
          <v-chip
            v-if="
              suggestedEntityFye &&
              model.currentFyeDate !== suggestedEntityFye &&
              !isSuggestionDismissed('currentFye', suggestedEntityFye)
            "
            size="x-small"
            variant="outlined"
            color="warning"
            prepend-icon="mdi-lightbulb-outline"
            closable
            close-icon="mdi-close"
            class="mt-1 cfye-suggest-chip"
            @click="model.currentFyeDate = suggestedEntityFye"
            @click:close="dismissSuggestion('currentFye', suggestedEntityFye)"
          >
            From entity: {{ formatIsoForSession(suggestedEntityFye) }}
          </v-chip>
        </v-col>
        <v-col cols="12" md="6">
          <v-menu v-model="newFyeMenu" :close-on-content-click="false" location="bottom" :disabled="!!readOnly">
            <template #activator="{ props: menuProps }">
              <v-text-field
                v-bind="menuProps"
                v-model="newFyeDisplay"
                :placeholder="newFyePlaceholder"
                label="New FYE date *"
                variant="outlined"
                density="compact"
                hide-details="auto"
                readonly
                append-inner-icon="mdi-calendar"
                :disabled="!!readOnly"
              />
            </template>
            <v-date-picker
              v-bind="newFyePickerProps"
              v-model="newFyePickerValue"
              @update:model-value="newFyeMenu = false"
            />
          </v-menu>
          <v-chip
            v-if="
              suggestedToday &&
              model.newFyeDate !== suggestedToday &&
              !isSuggestionDismissed('newFye', suggestedToday)
            "
            size="x-small"
            variant="outlined"
            color="warning"
            prepend-icon="mdi-lightbulb-outline"
            closable
            close-icon="mdi-close"
            class="mt-1 cfye-suggest-chip"
            @click="model.newFyeDate = suggestedToday"
            @click:close="dismissSuggestion('newFye', suggestedToday)"
          >
            Today: {{ formatIsoForSession(suggestedToday) }}
          </v-chip>
        </v-col>
      </v-row>
      <v-row dense class="mt-1">
        <v-col cols="12" md="4">
          <v-select
            v-model="model.newFinancialPeriodMonths"
            :items="financialYearPeriodItems"
            item-title="title"
            item-value="value"
            label="Financial year period *"
            variant="outlined"
            density="compact"
            hide-details="auto"
            :readonly="!!readOnly"
          />
        </v-col>
        <v-col cols="12" md="4">
          <v-menu v-model="nextFyStartMenu" :close-on-content-click="false" location="bottom" :disabled="!!readOnly">
            <template #activator="{ props: menuProps }">
              <v-text-field
                v-bind="menuProps"
                v-model="nextFyStartDisplay"
                :placeholder="nextFyStartPlaceholder"
                label="Next FY start date *"
                variant="outlined"
                density="compact"
                hide-details="auto"
                readonly
                append-inner-icon="mdi-calendar"
                :disabled="!!readOnly"
              />
            </template>
            <v-date-picker
              v-bind="nextFyStartPickerProps"
              v-model="nextFyStartPickerValue"
              @update:model-value="nextFyStartMenu = false"
            />
          </v-menu>
          <v-chip
            v-if="
              suggestedNextFyStart &&
              model.nextFyStartDate !== suggestedNextFyStart &&
              !isSuggestionDismissed('nextFyStart', suggestedNextFyStart)
            "
            size="x-small"
            variant="outlined"
            color="warning"
            prepend-icon="mdi-lightbulb-outline"
            closable
            close-icon="mdi-close"
            class="mt-1 cfye-suggest-chip"
            @click="model.nextFyStartDate = suggestedNextFyStart"
            @click:close="dismissSuggestion('nextFyStart', suggestedNextFyStart)"
          >
            Day after new FYE: {{ formatIsoForSession(suggestedNextFyStart) }}
          </v-chip>
        </v-col>
        <v-col cols="12" md="4">
          <v-menu v-model="nextFyEndMenu" :close-on-content-click="false" location="bottom" :disabled="!!readOnly">
            <template #activator="{ props: menuProps }">
              <v-text-field
                v-bind="menuProps"
                v-model="nextFyEndDisplay"
                :placeholder="nextFyEndPlaceholder"
                label="Next FY end date *"
                variant="outlined"
                density="compact"
                hide-details="auto"
                readonly
                append-inner-icon="mdi-calendar"
                :disabled="!!readOnly"
              />
            </template>
            <v-date-picker
              v-bind="nextFyEndPickerProps"
              v-model="nextFyEndPickerValue"
              @update:model-value="nextFyEndMenu = false"
            />
          </v-menu>
          <v-chip
            v-if="
              suggestedNextFyEnd &&
              model.nextFyEndDate !== suggestedNextFyEnd &&
              !isSuggestionDismissed('nextFyEnd', suggestedNextFyEnd)
            "
            size="x-small"
            variant="outlined"
            color="warning"
            prepend-icon="mdi-lightbulb-outline"
            closable
            close-icon="mdi-close"
            class="mt-1 cfye-suggest-chip"
            @click="model.nextFyEndDate = suggestedNextFyEnd"
            @click:close="dismissSuggestion('nextFyEnd', suggestedNextFyEnd)"
          >
            From period ({{ periodChipHint }}): {{ formatIsoForSession(suggestedNextFyEnd) }}
          </v-chip>
        </v-col>
      </v-row>
    </div>

    <div class="cfye-section">
      <div class="cfye-section-header">
        <Icon icon="mdi:gavel" width="16" color="#888" />
        <span>Resolution</span>
        <div v-if="docList.length" class="cfye-section-docs">
          <span class="cfye-section-docs-label">Applies to:</span>
          <v-chip
            v-for="(name, i) in docList.slice(0, MAX_DOC_CHIPS)"
            :key="'r-' + i"
            size="x-small"
            variant="tonal"
            color="primary"
            class="cfye-doc-chip"
          >
            {{ name }}
          </v-chip>
          <span v-if="docList.length > MAX_DOC_CHIPS" class="cfye-more-chip">
            +{{ docList.length - MAX_DOC_CHIPS }}
          </span>
        </div>
      </div>
      <v-row dense>
        <v-col cols="12" md="8">
          <v-combobox
            v-model="model.cspName"
            :items="cspNameOptions"
            label="CSP name (authorised filer) *"
            variant="outlined"
            density="compact"
            hide-details="auto"
            :readonly="!!readOnly"
            :disabled="!!readOnly"
            clearable
          />
        </v-col>
        <v-col cols="12" md="4">
          <v-menu v-model="resolutionMenu" :close-on-content-click="false" location="bottom" :disabled="!!readOnly">
            <template #activator="{ props: menuProps }">
              <v-text-field
                v-bind="menuProps"
                v-model="resolutionDisplay"
                :placeholder="resolutionPlaceholder"
                label="Resolution date *"
                variant="outlined"
                density="compact"
                hide-details="auto"
                readonly
                append-inner-icon="mdi-calendar"
                :disabled="!!readOnly"
              />
            </template>
            <v-date-picker
              v-bind="resolutionPickerProps"
              v-model="resolutionPickerValue"
              @update:model-value="resolutionMenu = false"
            />
          </v-menu>
          <v-chip
            v-if="
              suggestedToday &&
              model.resolutionDate !== suggestedToday &&
              !isSuggestionDismissed('resolutionDate', suggestedToday)
            "
            size="x-small"
            variant="outlined"
            color="warning"
            prepend-icon="mdi-lightbulb-outline"
            closable
            close-icon="mdi-close"
            class="mt-1 cfye-suggest-chip"
            @click="model.resolutionDate = suggestedToday"
            @click:close="dismissSuggestion('resolutionDate', suggestedToday)"
          >
            Today: {{ formatIsoForSession(suggestedToday) }}
          </v-chip>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref, watch } from 'vue';
import { Icon } from '@iconify/vue';
import {
  getCurrentDateByJurisdiction,
  useDateField,
  useFormatDateByUserFormat,
} from '@/shared/composables/dateUtils';
import { useSessionStore } from '@/shared/stores/sessionStore';
import { entityMyApi } from '@/features/Entity_my/api/entityApi';
import type { CfyeFormModel } from './composables/useFormPayload';

export interface CfyePresetDocument {
  templateName: string;
  docCode: string;
}

/** PreSetAGMPanel 과 동일 */
const MAX_DOC_CHIPS = 3;
const DEFAULT_DOC = 'DR (Change of FYE).docx';

const props = withDefaults(
  defineProps<{
    readOnly?: boolean;
    documents?: CfyePresetDocument[];
    /** 엔티티 프로필 FYE (YYYY-MM-DD) — Current FYE 제안 칩용 */
    entityFinancialYearEnd?: string;
    /** 챗에서 엔티티가 연결되면 비어있지 않음 — 세션 CLIENT_CD로 L_CLIENTS 조회 후 CSP 자동 채움 */
    entityLinkKey?: string;
  }>(),
  {
    readOnly: false,
    documents: () => [],
    entityFinancialYearEnd: '',
    entityLinkKey: '',
  },
);

const model = defineModel<CfyeFormModel>({ required: true });

const sessionStore = useSessionStore();
/** L_CLIENTS.CLIENT_NM — 콤보박스 후보 (세션 고객 1건) */
const cspNameOptions = ref<string[]>([]);

async function loadCspNameFromSessionClient() {
  const customer = sessionStore.getCustomerInfo();
  const clientCd = customer?.code || '';
  if (!clientCd) return;
  try {
    const res = await entityMyApi.getClientInfo(clientCd);
    const data = (res as any)?.data ?? res;
    const nm = String(data?.CLIENT_NM ?? data?.clientNm ?? '').trim();
    if (nm) {
      cspNameOptions.value = [nm];
      model.value.cspName = nm;
    }
  } catch (e) {
    console.warn('[ChangeFinancialYearEndForm] getClientInfo failed:', e);
  }
}

watch(
  () => props.entityLinkKey,
  (key) => {
    if (!key) return;
    void loadCspNameFromSessionClient();
  },
  { immediate: true },
);

/** DR / 정부 양식과 동일한 두 가지 회계기간 (문서 변수 `new_financial_period_months`에 그대로 전달) */
const financialYearPeriodItems = [
  { title: '12 months', value: '12 months' },
  { title: '52 weeks accounting period', value: '52 weeks accounting period' },
] as const;

const formatDateByUserFormat = useFormatDateByUserFormat();

function normalizeIso(v: unknown): string {
  if (v === null || v === undefined) return '';
  return String(v).trim();
}

function bindModelDate(
  get: () => string,
  set: (v: string) => void,
  field: ReturnType<typeof useDateField>,
) {
  watch(
    get,
    (v) => {
      const s = normalizeIso(v);
      if (field.dateValue.value !== s) field.dateValue.value = s;
    },
    { immediate: true },
  );
  watch(field.dateValue, (v) => {
    const s = normalizeIso(v);
    if (normalizeIso(get()) !== s) set(s);
  });
}

const currentFye = useDateField();
const newFye = useDateField();
const nextFyStart = useDateField();
const nextFyEnd = useDateField();
const resolution = useDateField();

bindModelDate(
  () => model.value.currentFyeDate,
  (v) => {
    model.value.currentFyeDate = v;
  },
  currentFye,
);
bindModelDate(
  () => model.value.newFyeDate,
  (v) => {
    model.value.newFyeDate = v;
  },
  newFye,
);
bindModelDate(
  () => model.value.nextFyStartDate,
  (v) => {
    model.value.nextFyStartDate = v;
  },
  nextFyStart,
);
bindModelDate(
  () => model.value.nextFyEndDate,
  (v) => {
    model.value.nextFyEndDate = v;
  },
  nextFyEnd,
);
bindModelDate(
  () => model.value.resolutionDate,
  (v) => {
    model.value.resolutionDate = v;
  },
  resolution,
);

const currentFyeMenu = currentFye.dateMenu;
const currentFyeDisplay = currentFye.dateDisplay;
const currentFyePickerValue = currentFye.datePickerValue;
const currentFyePlaceholder = currentFye.datePlaceholder;
const currentFyePickerProps = currentFye.datePickerProps;

const newFyeMenu = newFye.dateMenu;
const newFyeDisplay = newFye.dateDisplay;
const newFyePickerValue = newFye.datePickerValue;
const newFyePlaceholder = newFye.datePlaceholder;
const newFyePickerProps = newFye.datePickerProps;

const nextFyStartMenu = nextFyStart.dateMenu;
const nextFyStartDisplay = nextFyStart.dateDisplay;
const nextFyStartPickerValue = nextFyStart.datePickerValue;
const nextFyStartPlaceholder = nextFyStart.datePlaceholder;
const nextFyStartPickerProps = nextFyStart.datePickerProps;

const nextFyEndMenu = nextFyEnd.dateMenu;
const nextFyEndDisplay = nextFyEnd.dateDisplay;
const nextFyEndPickerValue = nextFyEnd.datePickerValue;
const nextFyEndPlaceholder = nextFyEnd.datePlaceholder;
const nextFyEndPickerProps = nextFyEnd.datePickerProps;

const resolutionMenu = resolution.dateMenu;
const resolutionDisplay = resolution.dateDisplay;
const resolutionPickerValue = resolution.datePickerValue;
const resolutionPlaceholder = resolution.datePlaceholder;
const resolutionPickerProps = resolution.datePickerProps;

const docList = computed(() => {
  const names = (props.documents || [])
    .map((d) => String(d.templateName || '').trim())
    .filter(Boolean);
  return names.length ? names : [DEFAULT_DOC];
});

const suggestedEntityFye = computed(() => normalizeIso(props.entityFinancialYearEnd));

const suggestedToday = computed(() => getCurrentDateByJurisdiction());

function addDaysIso(iso: string, days: number): string {
  if (!iso) return '';
  const m = iso.match(/^(\d{4})-(\d{1,2})-(\d{1,2})/);
  if (!m) return '';
  const d = new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
  if (isNaN(d.getTime())) return '';
  d.setDate(d.getDate() + days);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

function addMonthsIso(iso: string, monthsToAdd: number): string {
  if (!iso || !monthsToAdd) return '';
  const m = iso.match(/^(\d{4})-(\d{1,2})-(\d{1,2})/);
  if (!m) return '';
  const d = new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
  if (isNaN(d.getTime())) return '';
  d.setMonth(d.getMonth() + monthsToAdd);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

/** N개월 회계기간: 시작일 포함 N개월째의 전날 */
function periodEndFromStart(startIso: string, monthCount: number): string {
  if (!startIso || !monthCount || monthCount < 1) return '';
  return addDaysIso(addMonthsIso(startIso, monthCount), -1);
}

const suggestedNextFyStart = computed(() => {
  const n = normalizeIso(model.value.newFyeDate);
  return n ? addDaysIso(n, 1) : '';
});

function isTwelveMonthPeriodChoice(v: string): boolean {
  const s = String(v || '').trim();
  return s === '12 months' || /^\d+$/.test(s); // 구버전 숫자만 저장된 경우에도 12개월 제안에 가깝게 처리
}

function isFiftyTwoWeekPeriodChoice(v: string): boolean {
  return String(v || '').toLowerCase().includes('52 week');
}

/** 12개월 선택 시에만 월 단위 N, 그 외 0 */
const periodMonths = computed(() => {
  const raw = String(model.value.newFinancialPeriodMonths || '').trim();
  if (isTwelveMonthPeriodChoice(raw)) {
    const n = parseInt(raw, 10);
    if (Number.isFinite(n) && n > 0) return n;
    return 12;
  }
  return 0;
});

const periodChipHint = computed(() => {
  const raw = String(model.value.newFinancialPeriodMonths || '').trim();
  if (isFiftyTwoWeekPeriodChoice(raw)) return '52 wk';
  if (isTwelveMonthPeriodChoice(raw)) return `${periodMonths.value} mo`;
  return '';
});

const suggestedNextFyEnd = computed(() => {
  const start = normalizeIso(model.value.nextFyStartDate) || suggestedNextFyStart.value;
  const raw = String(model.value.newFinancialPeriodMonths || '').trim();
  if (!start || !raw) return '';
  if (isTwelveMonthPeriodChoice(raw)) {
    const pm = periodMonths.value;
    if (!pm) return '';
    return periodEndFromStart(start, pm);
  }
  if (isFiftyTwoWeekPeriodChoice(raw)) {
    // 52주 = 364일(7×52) 구간, 시작일 포함 말일 = 시작 + 363일
    return addDaysIso(start, 363);
  }
  return '';
});

function formatIsoForSession(iso: string): string {
  if (!iso) return '';
  const m = iso.match(/^(\d{4})-(\d{1,2})-(\d{1,2})/);
  if (!m) return iso;
  const d = new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]), 12, 0, 0);
  if (isNaN(d.getTime())) return iso;
  return formatDateByUserFormat(d);
}

const dismissedSuggestions = ref<Set<string>>(new Set());
function suggestionKey(field: string, value: string): string {
  return `${field}:${value}`;
}
function isSuggestionDismissed(field: string, value: string): boolean {
  if (!value) return true;
  return dismissedSuggestions.value.has(suggestionKey(field, value));
}
function dismissSuggestion(field: string, value: string) {
  if (!value) return;
  const next = new Set(dismissedSuggestions.value);
  next.add(suggestionKey(field, value));
  dismissedSuggestions.value = next;
}
</script>

<style scoped>
/* PreSetAGMPanel.vue `.agm-section` / `.agm-section-header` 와 동일 규격 */
.cfye-form {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.cfye-section {
  margin-bottom: 16px;
  background: #ffffff;
  border: 1px solid #e9edf5;
  border-radius: 12px;
  padding: 0 0 12px 0;
  overflow: hidden;
}

.cfye-section > :not(.cfye-section-header) {
  padding-left: 14px;
  padding-right: 14px;
}

.cfye-section-header {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  font-weight: 600;
  color: #283593;
  margin: 0 0 12px 0;
  padding: 10px 14px;
  background: linear-gradient(180deg, #eef2ff 0%, #e8ecfb 100%);
  border-bottom: 1px solid #d6dcf2;
}

.cfye-section-docs {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-left: 10px;
  flex-wrap: wrap;
}

.cfye-section-docs-label {
  font-size: 11px;
  color: #888;
  font-weight: 500;
}

.cfye-doc-chip {
  max-width: 240px;
}

.cfye-doc-chip :deep(.v-chip__content) {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.cfye-more-chip {
  font-size: 11px;
  color: #888;
}

/* PreSetAGMPanel `.agm-suggest-chip` 와 동일 */
.cfye-suggest-chip {
  cursor: pointer;
  font-size: 11px !important;
  background: #ffffff !important;
  color: #212121 !important;
  border-color: #ffb300 !important;
  border-width: 1px !important;
}
.cfye-suggest-chip:hover {
  background: #fff8e1 !important;
}
.cfye-suggest-chip :deep(.v-chip__content) {
  color: #212121 !important;
}
.cfye-suggest-chip :deep(.v-icon) {
  color: #ffb300 !important;
}
.cfye-suggest-chip :deep(.v-chip__close) {
  font-size: 13px !important;
  margin-inline-start: 4px;
  opacity: 0.7;
  color: #757575 !important;
}
.cfye-suggest-chip :deep(.v-chip__close:hover) {
  opacity: 1;
  color: #212121 !important;
}
</style>
